import React, {memo} from "react";

export const IconForward = memo(({color, width, height, addClass}) => {
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.40673 14.024C2.98573 12.655 3.81473 11.425 4.87073 10.369C5.92673 9.31296 7.15673 8.48396 8.52573 7.90496C9.94373 7.30496 11.4497 7.00096 13.0017 7.00096H16.2947L12.1487 2.85496C11.9537 2.65996 11.9537 2.34296 12.1487 2.14796C12.3437 1.95296 12.6607 1.95296 12.8557 2.14796L17.8557 7.14796C18.0507 7.34296 18.0507 7.65996 17.8557 7.85496L12.8557 12.855C12.7577 12.953 12.6297 13.001 12.5017 13.001C12.3737 13.001 12.2457 12.952 12.1477 12.855C11.9527 12.66 11.9527 12.343 12.1477 12.148L16.2937 8.00196H13.0007C7.21073 8.00196 2.50073 12.712 2.50073 18.502C2.50073 18.778 2.27673 19.002 2.00073 19.002C1.72473 19.002 1.50073 18.778 1.50073 18.502C1.50073 16.95 1.80473 15.444 2.40473 14.026L2.40673 14.024Z"
        fill={color || "#1BA2CC"}
      />
    </svg>
  );
});
